import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpclient.service';
import { FrontEnd } from '../../models/front-end.model';
import 'rxjs/Rx';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/Observable';
import { publishReplay, refCount } from 'rxjs/operators';

@Injectable()
export class FrontEndService {

  frontEnds: FrontEnd[];
  frontEndEditing: FrontEnd;
  private cachedFields: Observable<any>;

  constructor(
    private h: HttpClientService,
    private srvNotify: MessageService,
    private translate: TranslateService
  ) { }

  private notifySuccess() {
    this.translate.get(['common.success', 'common.operation_success']).subscribe(res => {
      this.srvNotify.add({ severity: 'info', summary: res['common.success'], detail: res['common.operation_success'] });
    });
  }

  list(
    offset = null,
    limit = null,
    search?: Array<{ key: string, value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number
  ): Observable<any> {
    const params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
    return this.h.getPaged('/koncentro-common/front-end' +
      (params.toString() ? '?' + params.toString().replace(/\+/gi, '%2B').replace(/'/gi, "''") : ''));
  }

  getAll() {
    return this.h.get('/koncentro-common/front-end')
      .map(res => {
        return this.frontEnds = res;
      });
  }

  getById(id) {
    return this.h.get('/koncentro-common/front-end/' + id);
  }

  delete(record) {
    return this.h.delete('/koncentro-common/front-end/' + record.id)
      .map(res => {
        this.notifySuccess();
      });
  }

  post(newData, silent = false) {
    return this.h.post('/koncentro-common/front-end', newData, silent)
      .map(res => {
        newData.id = res.id;
        this.notifySuccess();
      });
  }

  put(newData, silent = false) {
    return this.h.put('/koncentro-common/front-end/' + newData.id, newData, silent)
      .map(res => {
        Object.assign(this.frontEndEditing, newData);
        this.notifySuccess();
      });
  }

  recover(record) {
    const data = Object.assign({}, record, { flg_state: 0 });
    return this.h.put('/koncentro-common/front-end/' + record.id, data)
      .map(res => {
        this.notifySuccess();
      });
  }

  getFields() {
    if (!this.cachedFields) {
      this.cachedFields = this.h.get('/koncentro-common/schema/FrontEndDto').pipe(
        publishReplay(1),
        refCount()
      );
    }
    return this.cachedFields;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/front-end/front-end.service.ts